<template>
  <v-data-table
    class="base-table"
    :headers="headers"
    :items="items"
    :loading="loading"
    disable-pagination
    hide-default-footer
  >
    <template #item.name="props">
      <span class="clickable" @click="$emit('edit', props.item.id)">{{props.item.name}}</span>
    </template>
    <template #item.type="props">
      {{ getType(props.item.type) }}
    </template>
    <template #item.practice="props">
      {{ getCategory(categories, props.item).name }}
    </template>
    <template #item.practices="props">
      <v-list dense color="transparent">
        <div class="warmup-row" v-for="(item, index) in props.item.practices" :key="`${index}-exercise-${props.item.id}`">
          <v-list-item v-for="ex in item.exercises" :key="`${ex.id}-session-${props.item.id}`" color="transparent" class="pl-0">
            {{ ex.summary }}
          </v-list-item>
        </div>
      </v-list>
    </template>
    <template #item.id="props">
      <span class="clickable" @click="$emit('edit', props.item)">{{props.item.id}}</span>
    </template>
    <template #item.warmup="props">
      <v-list dense color="transparent">
        <div class="warmup-row" v-for="(item, index) in props.item.warmup" :key="`${index}-warm-up-${props.item.id}`">
          <v-list-item v-for="ex in item.exercises" :key="`${ex.id}-session-${props.item.id}`" color="transparent" class="pl-0">
            {{ ex.summary }}
          </v-list-item>
        </div>
      </v-list>
    </template>
    <template #item.exercise="props">
      <v-list-item v-for="item in props.item.exercise" :key="item.id" color="transparent" class="pl-0">
        {{ item.summary }}
      </v-list-item>
    </template>
    <template #item.homework="props">
      <v-list dense color="transparent">
        <div class="warmup-row" v-for="(item, index) in props.item.homework" :key="`${index}-homework-${props.item.id}`">
          <v-list-item v-for="ex in item.exercises" :key="`${ex.id}-session-${props.item.id}`" color="transparent" class="pl-0">
            {{ ex.summary }}
          </v-list-item>
        </div>
      </v-list>
    </template>
    <template #item.status="props">
      <v-chip :color="props.item.sessions.length === props.item.days ? 'success' : 'warning'">{{ props.item.sessions.length === props.item.days ? 'Approved' : 'Pending' }}</v-chip>
    </template>
    <template #item.status="props">
      <v-chip :color="props.item.sessions.length === props.item.days ? 'success' : 'warning'">{{ props.item.sessions.length === props.item.days ? 'Approved' : 'Pending' }}</v-chip>
    </template>
    <template #item.created="props">
      {{ props.item.created | formatDate }}
    </template>
    <template #item.users="props">
      {{ props.item.users.map(us => us.username).join(', ') }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn icon @click="$emit('delete-item', item.id)">
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { useHeaders } from '../composition-functions/useHeaders'

export default defineComponent({
  name: 'CommonTable',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    source: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    deletable: {
      type: Boolean,
      default: () => false,
    }
  },

  setup({ source, deletable }) {
    let { headers } = useHeaders(source);

    if (deletable) {
      headers = [...headers, { text: 'Actions', value: 'actions', sortable: false }]
    }

    /**
     * Get type
     * @param {number} type
     * */
    function getType(type) {
      let types = [];
      switch (source) {
        case 'coupon':
          types = [
            {
              index: 0,
              name: 'Month'
            },
            {
              index: 1,
              name: '3 Month'
            },
            {
              index: 2,
              name: 'Year'
            }
          ];
          break;
        default:
          types = [];
      }
      const tempType = types.find(t => t.index === type);
      return tempType.name;
    }

    return {
      headers,
      getType
    };
  }
});
</script>
